export { makeRumPublicApi, } from './boot/rumPublicApi';
export { startRum } from './boot/startRum';
export { LifeCycle, LifeCycleEventType } from './domain/lifeCycle';
export { getMutationObserverConstructor } from './browser/domMutationObservable';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/~/@datadog/browser-rum-core/esm/index.js
// module id = ../../../../@datadog/browser-rum-core/esm/index.js
// module chunks = 5